/**
 * Google Analytics Service provides GTM enhanced ecommerce events.
 */
class GoogleAnalyticsService {
  /* global dataLayer */

  /**
   * Track Data Object passed
   * @param  {object}   dataObj data to track
   * @return {object}          null
   */
  trackDataObject = (dataObj) => {
    try {
      if (dataLayer) {
        dataLayer.push(dataObj);
      }
    } catch (e) {
      if (dataObj.eventCallback) { dataObj.eventCallback.apply(); }
    }
  };

  /**
   * Track search results for GTM enhanced ecommerce tracking
   * @param  {object}   dataObj contains search term and total result
   * @return {object}          null
   */
  trackSearchResults = (dataObj, callback) => {
    const ecommerceObject = {
      event: 'searchResults',
      ecommerce: {
        search: dataObj,
      },
    };
    if (callback) {
      ecommerceObject.eventCallback = callback;
    }
    this.trackDataObject(ecommerceObject);
  };

  /**
   * Track products pruchased for GTM enhanced ecommerce tracking
   * @param  {object}   dataObj contains details of product purchased
   * @return {object}          null
   */
  trackProductsPurchased = (dataObj, callback) => {
    const ecommerceObject = {
      event: 'purchase',
      ecommerce: {
        purchase: dataObj,
      },
    };
    if (callback) {
      ecommerceObject.eventCallback = callback;
    }
    this.trackDataObject(ecommerceObject);
  };

  /**
   * Track product impressions for GTM enhanced ecommerce tracking
   * @param  {object}   dataObj contains product details for PDP
   * @return {object}          null
   */
  trackImpressions = (dataObj, currencyCode, callback) => {
    const ecommerceObject = {
      event: 'productImpressions',
      ecommerce: {
        currencyCode,
        impressions: dataObj,
      },
    };
    if (callback) {
      ecommerceObject.eventCallback = callback;
    }
    this.trackDataObject(ecommerceObject);
  };

  /**
   * Track product details impressions results for GTM enhanced ecommerce tracking
   * @param  {object}   dataObj contains product details for PDP
   * @return {object}          null
   */
  trackDetailImpressions = (dataObj, callback) => {
    const ecommerceObject = {
      event: 'productDetail',
      ecommerce: {
        detail: {
          actionField: {
            list: '',
          },
          products: dataObj,
        },
      },
    };
    if (callback) {
      ecommerceObject.eventCallback = callback;
    }
    this.trackDataObject(ecommerceObject);
  };

  /**
   * Track product add to cart for GTM enhanced ecommerce tracking
   * @param  {object}   dataObj contains details of product added to cart
   * @return {object}          null
   */
  trackAddToCart = (dataObj, callback) => {
    const ecommerceObject = {
      event: 'addToCart',
      ecommerce: {
        add: dataObj,
      },
    };
    if (callback) {
      ecommerceObject.eventCallback = callback;
    }
    this.trackDataObject(ecommerceObject);
  };

  /**
   * Track product cart removal for GTM enhanced ecommerce tracking
   * @param  {object}   dataObj contains details of product removed from cart
   * @return {object}          null
   */
  trackRemoveFromCart = (dataObj, callback) => {
    const ecommerceObject = {
      event: 'removeFromCart',
      ecommerce: {
        remove: dataObj,
      },
    };
    if (callback) {
      ecommerceObject.eventCallback = callback;
    }
    this.trackDataObject(ecommerceObject);
  };

  /**
   * Track checkout information for GTM enhanced ecommerce tracking
   * @param  {object}   dataObj contains details of product during checkout
   * @return {object}          null
   */
  trackCheckout = (dataObj, callback) => {
    if (dataObj) {
      const ecommerceObject = {
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: {
              step: 1,
              option: 'Checkout Initialized',
            },
            products: dataObj,
          },
        },
      };
      if (callback) {
        ecommerceObject.eventCallback = callback;
      }
      this.trackDataObject(ecommerceObject);
    }
  };

  /**
   * Track marketing form post related information
   * @param  {object}   dataObj contains details of form post
   * @return {object}          null
   */
  trackMarketingFormPost = (dataObj, callback) => {
    if (dataObj) {
      const ecommerceObject = dataObj;
      if (callback) {
        ecommerceObject.eventCallback = callback;
      }
      this.trackDataObject(ecommerceObject);
    }
  };
}

export default GoogleAnalyticsService;



// WEBPACK FOOTER //
// ./src/components/common/services/google-analytics-service.js